module.exports = __webpack_public_path__ + "images/emoji/ski.21c98328aa3957ac9753.png";